<template>
  <div class="circular-loader">
    <div class="circular-loader__overlay">
      <div class="circular-loader__progress"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes loader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.circular-loader {
  padding: 5px;

  &__overlay {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 4px 0px rgba(34, 60, 80, 0.1);
    -moz-box-shadow: 0px 0px 4px 0px rgba(34, 60, 80, 0.1);
    box-shadow: 0px 0px 4px 0px rgba(34, 60, 80, 0.1);
  }

  &__progress {
    display: block;
    margin: 7px auto;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    animation: loader 1.4s infinite linear;
    transform: translateZ(0);
  }

  &__progress:before {
    display: block;
    width: 50%;
    height: 50%;
    background: #f14635;
    border-radius: 100% 0 0 0;
    content: "";
  }

  &__progress:after {
    display: block;
    background: #fff;
    width: 80%;
    height: 80%;
    border-radius: 50%;
    content: "";
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
